import { render, staticRenderFns } from "./LmComments.vue?vue&type=template&id=2d1ca2f4&"
import script from "./LmComments.vue?vue&type=script&lang=js&"
export * from "./LmComments.vue?vue&type=script&lang=js&"
import style0 from "./LmComments.vue?vue&type=style&index=0&id=2d1ca2f4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports